/**
 * Auto-generated by tools/content-pipeline.
 * Pack: trivia-era-expansion-v1
 * Item: music-60s-expansion
 * Generated: 2026-07-14T00:59:16.821Z
 * Generator: google/gemini-2.5-flash  |  Judge: anthropic/claude-sonnet-4.5
 * Accepted: 46 items (judge threshold 0.70)
 * Edit this file by re-running the pipeline; do not hand-edit unless you know what you are doing.
 */

export const generatedMusic60s = [
  {
    "question": "Which singer-songwriter was known for his gravelly voice and poetic lyrics, particularly during the folk revival of the 1960s?",
    "options": [
      "Paul Simon",
      "Bob Dylan",
      "Pete Seeger",
      "Leonard Cohen"
    ],
    "correctIndex": 1,
    "difficulty": "easy",
    "blurb": "Bob Dylan's influence on music and culture in the 60s is still felt today."
  },
  {
    "question": "The Supremes' hit song 'Baby Love' was released in what year?",
    "options": [
      "1962",
      "1964",
      "1966",
      "1968"
    ],
    "correctIndex": 1,
    "difficulty": "medium",
    "blurb": "Baby Love was The Supremes' second number one hit and a Motown classic."
  },
  {
    "question": "Marvin Gaye's 1968 hit, 'I Heard It Through the Grapevine,' was first recorded by which Motown group in 1967?",
    "options": [
      "The Temptations",
      "The Four Tops",
      "Gladys Knight & the Pips",
      "Smokey Robinson & The Miracles"
    ],
    "correctIndex": 2,
    "difficulty": "hard",
    "blurb": "Gladys Knight & the Pips actually released their version of the song a year before Marvin Gaye."
  },
  {
    "question": "Which psychedelic Beatles album from 1967 features a prominent collage of figures on its cover?",
    "options": [
      "Revolver",
      "Sgt. Pepper's Lonely Hearts Club Band",
      "Magical Mystery Tour",
      "Rubber Soul"
    ],
    "correctIndex": 1,
    "difficulty": "easy",
    "blurb": "Sgt. Pepper's is often considered one of the most influential albums ever made."
  },
  {
    "question": "Which folk icon sang 'Blowin' in the Wind,' a prominent protest song of the 1960s civil rights movement?",
    "options": [
      "Joan Baez",
      "Bob Dylan",
      "Pete Seeger",
      "Woody Guthrie"
    ],
    "correctIndex": 1,
    "difficulty": "easy",
    "blurb": "Many artists, including Peter, Paul and Mary, covered this Bob Dylan classic."
  },
  {
    "question": "Which Motown group, known for their smooth harmonies, sang 'My Girl'?",
    "options": [
      "The Four Tops",
      "The Temptations",
      "Smokey Robinson & The Miracles",
      "The Jackson 5"
    ],
    "correctIndex": 1,
    "difficulty": "easy",
    "blurb": "That iconic guitar riff at the beginning of My Girl is instantly recognizable."
  },
  {
    "question": "Which artist had a hit with the song 'Happy Together' in 1967?",
    "options": [
      "The Monkees",
      "The Turtles",
      "The Lovin' Spoonful",
      "The Grass Roots"
    ],
    "correctIndex": 1,
    "difficulty": "medium",
    "blurb": "Happy Together was the biggest hit for The Turtles, reaching number one in the US."
  },
  {
    "question": "Which female artist, known as the 'Queen of Soul,' released 'Respect' in 1967?",
    "options": [
      "Diana Ross",
      "Etta James",
      "Tina Turner",
      "Aretha Franklin"
    ],
    "correctIndex": 3,
    "difficulty": "easy",
    "blurb": "Aretha Franklin's rendition of Respect became an anthem for civil rights and feminism."
  },
  {
    "question": "Which legendary country singer crossed over into pop with hits like 'Ring of Fire' in 1963?",
    "options": [
      "Waylon Jennings",
      "Willie Nelson",
      "Johnny Cash",
      "Merle Haggard"
    ],
    "correctIndex": 2,
    "difficulty": "easy",
    "blurb": "Johnny Cash's deep voice and outlaw image made him a unique figure in music."
  },
  {
    "question": "The Beach Boys' classic album 'Pet Sounds' was released in what year?",
    "options": [
      "1964",
      "1966",
      "1968",
      "1969"
    ],
    "correctIndex": 1,
    "difficulty": "medium",
    "blurb": "Many musicians consider Pet Sounds to be one of the greatest albums of all time."
  },
  {
    "question": "Which singer-songwriter, known for his unique vocal range and dark sunglasses, sang 'Oh, Pretty Woman' in 1964?",
    "options": [
      "Elvis Presley",
      "Buddy Holly",
      "Roy Orbison",
      "Gene Pitney"
    ],
    "correctIndex": 2,
    "difficulty": "medium",
    "blurb": "Roy Orbison's dramatic ballads and powerful voice set him apart."
  },
  {
    "question": "Which American folk rock duo released 'Mrs. Robinson' in 1968, famously featured in 'The Graduate'?",
    "options": [
      "The Everly Brothers",
      "Simon & Garfunkel",
      "Crosby, Stills & Nash",
      "Peter, Paul and Mary"
    ],
    "correctIndex": 1,
    "difficulty": "easy",
    "blurb": "The Graduate helped make Simon & Garfunkel household names."
  },
  {
    "question": "Which Motown singer, known for his smooth voice, had a major hit with 'What's Going On' in 1971, but also many hits in the 60s?",
    "options": [
      "Smokey Robinson",
      "Marvin Gaye",
      "Jackie Wilson",
      "Al Green"
    ],
    "correctIndex": 1,
    "difficulty": "easy",
    "blurb": "Marvin Gaye's music evolved from smooth soul to socially conscious funk."
  },
  {
    "question": "Which British band, led by Roger Daltrey and Pete Townshend, smashed their instruments on stage?",
    "options": [
      "The Kinks",
      "The Who",
      "Led Zeppelin",
      "Cream"
    ],
    "correctIndex": 1,
    "difficulty": "medium",
    "blurb": "The Who was famous for their energetic and destructive live performances."
  },
  {
    "question": "Which Motown group sang 'Heat Wave' in 1963?",
    "options": [
      "Martha Reeves and the Vandellas",
      "The Marvelettes",
      "The Supremes",
      "The Shirelles"
    ],
    "correctIndex": 0,
    "difficulty": "hard",
    "blurb": "Heat Wave was a major hit for Martha Reeves and the Vandellas, a vibrant Motown sound."
  },
  {
    "question": "Which British band had a hit with 'Wild Thing' in 1966?",
    "options": [
      "The Animals",
      "The Troggs",
      "The Yardbirds",
      "The Small Faces"
    ],
    "correctIndex": 1,
    "difficulty": "medium",
    "blurb": "Wild Thing is known for its simple, raw garage rock sound."
  },
  {
    "question": "Which iconic Beatles album, released in 1969, features the band walking across a street crossing?",
    "options": [
      "Revolver",
      "Sgt. Pepper's Lonely Hearts Club Band",
      "Abbey Road",
      "Let It Be"
    ],
    "correctIndex": 2,
    "difficulty": "easy",
    "blurb": "That crosswalk on Abbey Road is still a London tourist stop today."
  },
  {
    "question": "What was the name of the popular dance craze started by Chubby Checker in the early 1960s?",
    "options": [
      "The Mashed Potato",
      "The Twist",
      "The Shimmy",
      "The Locomotion"
    ],
    "correctIndex": 1,
    "difficulty": "easy",
    "blurb": "The Twist was a global phenomenon and one of the first dances where partners didn't need to touch."
  },
  {
    "question": "Which soul singer's 1964 hit 'A Change Is Gonna Come' became an anthem of the Civil Rights Movement?",
    "options": [
      "James Brown",
      "Otis Redding",
      "Sam Cooke",
      "Jackie Wilson"
    ],
    "correctIndex": 2,
    "difficulty": "medium",
    "blurb": "Sam Cooke wrote this song after his band was turned away from a whites-only motel."
  },
  {
    "question": "Which band, known for their surf rock sound, sang 'Good Vibrations' in 1966?",
    "options": [
      "The Ventures",
      "Jan and Dean",
      "The Beach Boys",
      "Dick Dale & The Del-Tones"
    ],
    "correctIndex": 2,
    "difficulty": "easy",
    "blurb": "Good Vibrations is renowned for its complex musical structure and innovative production."
  },
  {
    "question": "Which female vocalist, known for her powerful voice, fronted Big Brother and the Holding Company in the late 1960s?",
    "options": [
      "Grace Slick",
      "Janis Joplin",
      "Bonnie Raitt",
      "Linda Ronstadt"
    ],
    "correctIndex": 1,
    "difficulty": "medium",
    "blurb": "Janis Joplin was a true rock and roll legend, though her career was tragically short."
  },
  {
    "question": "Which Beatle was often called the 'Quiet Beatle'?",
    "options": [
      "John Lennon",
      "Paul McCartney",
      "George Harrison",
      "Ringo Starr"
    ],
    "correctIndex": 2,
    "difficulty": "easy",
    "blurb": "George Harrison was a talented guitarist and songwriter, contributing many great songs to The Beatles."
  },
  {
    "question": "The Temptations' hit 'Ain't Too Proud to Beg' was released in which year?",
    "options": [
      "1964",
      "1966",
      "1968",
      "1962"
    ],
    "correctIndex": 1,
    "difficulty": "medium",
    "blurb": "Ain't Too Proud to Beg became a signature song for The Temptations, showcasing their harmonies and choreography."
  },
  {
    "question": "Which instrument became synonymous with Jimi Hendrix's legendary performances in the late 1960s?",
    "options": [
      "Drums",
      "Bass Guitar",
      "Electric Guitar",
      "Keyboard"
    ],
    "correctIndex": 2,
    "difficulty": "easy",
    "blurb": "Jimi Hendrix redefined what was possible with an electric guitar."
  },
  {
    "question": "Which British band famously sang 'House of the Rising Sun' in 1964?",
    "options": [
      "The Rolling Stones",
      "The Animals",
      "The Who",
      "The Kinks"
    ],
    "correctIndex": 1,
    "difficulty": "medium",
    "blurb": "The Animals' version of this traditional folk song became a huge transatlantic hit."
  },
  {
    "question": "Which American singer, known for his soulful voice and charismatic stage presence, released 'Papa's Got a Brand New Bag' in 1965?",
    "options": [
      "Sam Cooke",
      "Jackie Wilson",
      "James Brown",
      "Marvin Gaye"
    ],
    "correctIndex": 2,
    "difficulty": "medium",
    "blurb": "James Brown is considered the 'Godfather of Soul' and deeply influenced funk music."
  },
  {
    "question": "Which folk singer, known for political activism, sang 'Where Have All the Flowers Gone?'?",
    "options": [
      "Joan Baez",
      "Woody Guthrie",
      "Pete Seeger",
      "Phil Ochs"
    ],
    "correctIndex": 2,
    "difficulty": "medium",
    "blurb": "Pete Seeger was a powerful voice for social justice and folk music."
  },
  {
    "question": "Which 1968 Beatles song features a famous guitar solo by Eric Clapton?",
    "options": [
      "While My Guitar Gently Weeps",
      "Come Together",
      "Revolution",
      "Helter Skelter"
    ],
    "correctIndex": 0,
    "difficulty": "hard",
    "blurb": "George Harrison asked his friend Eric Clapton to play the solo to add a different flavor to the song."
  },
  {
    "question": "Which British Invasion band covered the song 'Twist and Shout' becoming a signature hit?",
    "options": [
      "The Kinks",
      "The Beatles",
      "The Animals",
      "The Rolling Stones"
    ],
    "correctIndex": 1,
    "difficulty": "easy",
    "blurb": "The Beatles' energetic live performances, including Twist and Shout, captivated audiences."
  },
  {
    "question": "In 1969, which singer performed 'The Star-Spangled Banner' at Woodstock using heavy distortion and feedback?",
    "options": [
      "Bob Dylan",
      "Janis Joplin",
      "Jimi Hendrix",
      "Joe Cocker"
    ],
    "correctIndex": 2,
    "difficulty": "easy",
    "blurb": "Jimi Hendrix's iconic performance of the anthem is one of the defining moments of Woodstock."
  },
  {
    "question": "Which Motown artist had a hit in 1965 asking 'Ain't That Peculiar'?",
    "options": [
      "The Temptations",
      "Marvin Gaye",
      "Smokey Robinson",
      "Stevie Wonder"
    ],
    "correctIndex": 1,
    "difficulty": "medium",
    "blurb": "Marvin Gaye continued to churn out hits throughout the decade."
  },
  {
    "question": "Which folk-rock group famously covered Bob Dylan's 'Mr. Tambourine Man' in 1965?",
    "options": [
      "The Mamas & the Papas",
      "The Byrds",
      "Crosby, Stills & Nash",
      "The Lovin' Spoonful"
    ],
    "correctIndex": 1,
    "difficulty": "medium",
    "blurb": "The Byrds' electric folk sound brought Dylan's music to a wider audience."
  },
  {
    "question": "Which iconic British singer was known for her blue-eyed soul and hits like 'Son of a Preacher Man'?",
    "options": [
      "Lulu",
      "Cilla Black",
      "Dusty Springfield",
      "Marianne Faithfull"
    ],
    "correctIndex": 2,
    "difficulty": "medium",
    "blurb": "Dusty Springfield was one of the key figures of the 'British Invasion' pop scene."
  },
  {
    "question": "Which Beatles album, released in 1965, marked a significant step towards psychedelic rock and folk influence?",
    "options": [
      "Rubber Soul",
      "Please Please Me",
      "A Hard Day's Night",
      "Help!"
    ],
    "correctIndex": 0,
    "difficulty": "medium",
    "blurb": "Rubber Soul is often seen as a turning point in the Beatles' musical evolution."
  },
  {
    "question": "Which American band, known for their harmonious sound, sang 'California Dreamin'' in 1965?",
    "options": [
      "The Turtles",
      "The Byrds",
      "The Mamas & the Papas",
      "Crosby, Stills & Nash"
    ],
    "correctIndex": 2,
    "difficulty": "easy",
    "blurb": "California Dreamin' is an iconic song of the Counterculture era."
  },
  {
    "question": "Which British band, fronted by Mick Jagger, released 'Paint It Black' in 1966?",
    "options": [
      "The Animals",
      "The Yardbirds",
      "The Rolling Stones",
      "The Kinks"
    ],
    "correctIndex": 2,
    "difficulty": "easy",
    "blurb": "Paint It Black features a distinctive sitar riff, adding an exotic sound."
  },
  {
    "question": "Which iconic festival in 1969 featured performances by Jimi Hendrix, Janis Joplin, and The Who?",
    "options": [
      "Monterey Pop Festival",
      "Newport Folk Festival",
      "Woodstock",
      "Isle of Wight Festival"
    ],
    "correctIndex": 2,
    "difficulty": "easy",
    "blurb": "Woodstock became a symbol of the counterculture generation and a legendary event in music history."
  },
  {
    "question": "Who was the lead singer of The Supremes, who went on to a successful solo career?",
    "options": [
      "Mary Wilson",
      "Florence Ballard",
      "Cindy Birdsong",
      "Diana Ross"
    ],
    "correctIndex": 3,
    "difficulty": "easy",
    "blurb": "Diana Ross's charisma and talent made The Supremes one of Motown's biggest acts."
  },
  {
    "question": "Which soulful singer had hits like 'Stand By Me' in 1961?",
    "options": [
      "Sam Cooke",
      "Ben E. King",
      "Percy Sledge",
      "Marvin Gaye"
    ],
    "correctIndex": 1,
    "difficulty": "medium",
    "blurb": "Stand By Me remains a timeless classic, recognized by millions."
  },
  {
    "question": "Which soul artist released 'Dock of the Bay' posthumously in 1968?",
    "options": [
      "Sam Cooke",
      "Marvin Gaye",
      "Otis Redding",
      "James Brown"
    ],
    "correctIndex": 2,
    "difficulty": "easy",
    "blurb": "Otis Redding tragically died in a plane crash just three days after recording this song."
  },
  {
    "question": "Which British pop group, fronted by Gerry Marsden, had a hit with 'Ferry Cross the Mersey'?",
    "options": [
      "The Searchers",
      "Gerry and the Pacemakers",
      "The Dave Clark Five",
      "Herman's Hermits"
    ],
    "correctIndex": 1,
    "difficulty": "hard",
    "blurb": "Gerry and the Pacemakers were a prominent part of the Merseybeat scene alongside The Beatles."
  },
  {
    "question": "Which Motown girl group achieved success with hits like 'Please Mr. Postman'?",
    "options": [
      "The Supremes",
      "The Shirelles",
      "Martha Reeves and the Vandellas",
      "The Marvelettes"
    ],
    "correctIndex": 3,
    "difficulty": "medium",
    "blurb": "The Marvelettes' 'Please Mr. Postman' was Motown's very first number one hit on the Billboard Hot 100."
  },
  {
    "question": "Which rock and roll legend, known as 'The King,' continued to have hits throughout the 1960s?",
    "options": [
      "Chuck Berry",
      "Jerry Lee Lewis",
      "Elvis Presley",
      "Little Richard"
    ],
    "correctIndex": 2,
    "difficulty": "easy",
    "blurb": "Elvis's iconic status endured, even through his acting career in the 60s."
  },
  {
    "question": "Which British band, fronted by Eric Burdon, had a hit with 'We Gotta Get Out of This Place'?",
    "options": [
      "The Kinks",
      "The Animals",
      "The Yardbirds",
      "The Zombies"
    ],
    "correctIndex": 1,
    "difficulty": "medium",
    "blurb": "The Animals were a key part of the British Invasion, known for their blues-rock sound."
  },
  {
    "question": "Which Motown group, known for their intricate choreography, sang 'My Girl'?",
    "options": [
      "The Four Tops",
      "The Miracles",
      "The Temptations",
      "Jackson 5"
    ],
    "correctIndex": 2,
    "difficulty": "easy",
    "blurb": "The Temptations' dynamic stage presence and harmonies were legendary."
  },
  {
    "question": "Which blues-rock supergroup, featuring Eric Clapton, released 'Sunshine of Your Love' in 1967?",
    "options": [
      "Led Zeppelin",
      "The Jeff Beck Group",
      "Cream",
      "Blind Faith"
    ],
    "correctIndex": 2,
    "difficulty": "hard",
    "blurb": "Cream was one of the first successful rock supergroups, pushing the boundaries of blues rock."
  }
] as const;
